import { useCountReviewView, usePublicReviewForm, useSubmitReview } from '@fidalia/api';
import { Skeleton } from '@fidalia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { PublicFormError } from '@/features/reviews/public-form-error';
import { ReviewFlow, ReviewPage } from '@/features/reviews/review-flow';

/** Public page, no auth: the patient arrives from the review request link. */
export const Route = createFileRoute('/reviews/$token')({
  component: PublicReviewPage,
});

/** Page-sized frame: the bottom room is for the form's fixed « Envoyer » bar. */
const PAGE = 'min-h-dvh pb-28 sm:pb-12';

function PublicReviewPage() {
  const { token } = Route.useParams();
  // The token says who the patient is (from the email) or nothing (the cabinet's public
  // link): then the visitor can leave an optional name instead.
  const { data: form, isPending, isError, error, refetch } = usePublicReviewForm(token);
  useCountReviewView(token);
  const submitReview = useSubmitReview(token);

  // « Coup de cœur » : le praticien a choisi ce patient, il va droit sur Google sans formulaire.
  const directUrl = form?.directUrl?.startsWith('https://') ? form.directUrl : null;
  useEffect(() => {
    if (directUrl) globalThis.location.replace(directUrl);
  }, [directUrl]);

  if (isPending) {
    return (
      <ReviewPage className={PAGE}>
        <Skeleton className="h-96 w-full max-w-lg rounded-card" />
      </ReviewPage>
    );
  }
  if (isError) {
    return (
      <ReviewPage className={PAGE}>
        <div className="w-full max-w-lg">
          <PublicFormError error={error} onRetry={() => void refetch()} />
        </div>
      </ReviewPage>
    );
  }

  if (directUrl) {
    return (
      <ReviewPage className={PAGE}>
        <Skeleton className="h-96 w-full max-w-lg rounded-card" />
      </ReviewPage>
    );
  }

  return <ReviewFlow form={form} pageClassName={PAGE} onSubmit={submitReview.mutateAsync} />;
}
